import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Formik, ErrorMessage } from 'formik'
import * as yup from 'yup'
import _ from 'lodash'

// components
import { Button, TextInput } from '../../../shard'
import { Size, Color } from '../../../../const'
import Alert from 'components/Alert'

// hooks
import { useLoginHook } from 'hooks'
import { useHistory } from 'react-router-dom'
import WrapperLink from 'components/shard/WrapperLink'

const schema = () =>
  yup.object().shape({
    tanakaId: yup
      .string()
      .matches(/^[a-zA-Z0-9!?@._+-]*$/, { message: '半角英数で入力してください' })
      .required('項目が未入力です'),
    password: yup
      .string()
      .matches(/^[a-zA-Z0-9!?@._-]*$/, { message: '半角英数で入力してください' })
      .required('項目が未入力です'),
  })

function Login({ qs }) {
  const history = useHistory()
  const [values, setValues] = useState({})
  const [isRedirectErrorOpen, setIsRedirectErrorOpen] = useState(qs.redirected === 'true')
  const {
    isLoginRequesting,
    loginErrors,
    setLoginErrors,
    isLoginSuccess,
    execLogIn,
    resetStorageFunc,
    isSwitched,
    isAgreement,
  } = useLoginHook()

  useEffect(() => {
    const logIn = async () => {
      if (_.isEmpty(values)) {
        return
      }
      await execLogIn(values)
    }

    logIn()
  }, [values, execLogIn])

  useEffect(() => {
    if (isLoginSuccess) {
      /* 登録されていなければtanakaIdの変更画面へ */
      if (!isSwitched) {
        history.push('/tanakaid/switch')

        return
      }

      /* 登録が済んでいるが,規約に同意していない場合は、規約ページに遷移 */
      if (!isAgreement) {
        history.push('/signup')

        return
      }
      /* 上記が満たされれば会員ページTOPへ */
      history.push('/top')
    }
  }, [isLoginSuccess, history, isSwitched, isAgreement])

  useEffect(() => {
    if (qs.redirected === 'true') {
      resetStorageFunc()
    }
  }, [qs.redirected, resetStorageFunc])

  return (
    <Wrapper>
      {loginErrors.length > 0 && (
        <Alert type="error" message="エラー" description={loginErrors.join('\n')} onClose={() => setLoginErrors([])} />
      )}
      {isRedirectErrorOpen && (
        <Alert
          type="error"
          message="エラー"
          description="APIキーが無効であるため、ログアウトされました"
          onClose={() => setIsRedirectErrorOpen(false)}
        />
      )}
      <TitleBlock>ログイン</TitleBlock>
      <FormWrapper>
        <Formik
          initialValues={{ tanakaId: '', password: '' }}
          onSubmit={(values) => {
            setValues(values)
          }}
          validationSchema={schema}
        >
          {({ values, handleChange, handleBlur, handleSubmit, dirty, isSubmitting, isValid }) => (
            <form
              onSubmit={(e) => {
                e.preventDefault() // useEffectでstateを更新するためにcomponentの自動更新を防ぐ
                handleSubmit(e)
              }}
            >
              <TextInput
                type="email"
                name="tanakaId"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.tanakaId}
                ariaLabel="tanakaId"
                placeholder="TANAKA-ID（メールアドレス）"
                errorMessage={<ErrorMessage name="tanakaId" />}
              />
              <TextInput
                type="password"
                name="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
                ariaLabel="password"
                placeholder="パスワード"
                errorMessage={<ErrorMessage name="password" />}
              />
              <Message>TANAKA-IDはご来店時登録いただいたID（メールアドレス）です。</Message>
              <ButtonWrapper>
                <Button type={'submit'} primary disabled={!isValid || !dirty || isLoginRequesting}>
                  ログイン
                </Button>
              </ButtonWrapper>
              <IdLinkWrapper>
                <IdLink to="/password">パスワードを忘れた方</IdLink>
              </IdLinkWrapper>
              <AboutLinkWrapper>
                <AboutLink href="https://www.tanaka-megane.co.jp/mytanaka/" target="_blank" rel="noopener noreferrer">
                  My TANAKA会員サービスについて詳しくはこちら
                </AboutLink>
              </AboutLinkWrapper>
            </form>
          )}
        </Formik>
      </FormWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: 30px 20px;
`

const TitleBlock = styled.div`
  color: ${Color.FONT.NORMAL};
  font-size: ${Size.FONT.HEADLINE.SMALL};
  padding: 40px 0px 20px 0px;
  border-bottom: 1px solid #ccc;
`

const FormWrapper = styled.div`
  grid-column: 2;
  grid-row: 3;
  padding-top: 20px;
`

const Message = styled.div`
  padding: 10px 0;
  color: ${Color.FONT.ANNOTATION};
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`

const IdLinkWrapper = styled.div`
  text-align: center;
  padding-top: 40px;
`

const IdLink = styled(WrapperLink)`
  color: ${Color.FONT.ANNOTATION};
  text-decoration-line: underline;
`
const AboutLinkWrapper = styled.div`
  padding: 80px 0 30px 20px;
`
const AboutLink = styled.a`
  color: ${Color.FONT.ANNOTATION};
  text-decoration-line: underline;
`

Login.propTypes = {
  qs: PropTypes.object,
}

export default Login
